module["exports"] = ["", "חדשה", "עלית"];